import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@/lib/seo";
import Gutters from "@/pages/services/Gutters";

export const Route = createFileRoute("/_site/services/gutters")({
  head: () => ({
    ...seo({
      title: "Gutter Installation & Repair | Kodiak Structures & Exteriors",
      description:
        "Seamless gutter installation and repair throughout Minnesota. Protect your foundation and landscaping with custom-fit gutters. Free estimates.",
      path: "/services/gutters",
    }),
  }),
  component: Gutters,
});
